import React from "react";

import Sidebar from "components/sidebar/Sidebar.js";

import {
  Box,
  useColorModeValue,
  Portal,
  useDisclosure,
  SimpleGrid,
} from "@chakra-ui/react";
import { useMemo, useState, useEffect } from "react";

import Navbar from "components/navbar/NavbarAdmin.js";
import axios from "axios";
import { SidebarContext } from "contexts/SidebarContext";

import { fetchList } from "api/function";
import Loader from "components/Loader";
import routes from "routes.js";

import {
  getActiveRoute,
  getActiveNavbar,
  getActiveNavbarText,
} from "helper/UploadFilePageHelper";

import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import { useLocation } from "react-router-dom";

import CheckTable from "../AnalyticsPage/components/CheckTable";
import DailyTraffic from "../AnalyticsPage/components/DailyTraffic";
import TableComponent from "./components/TableComponent";
const api_url = process.env.REACT_APP_API;

export default function TrifectaPage(props) {
  const { onOpen } = useDisclosure();

  const [loading, setLoading] = useState(true);
  const [modalLoading, setModalLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);

  const [data, setData] = useState([]);
  const [datasets, setDatasets] = useState([]);

  const fetchListTrifecta = async (url) => {
    try {
      const response = await axios.get(`${api_url}${url}`);
      return response;
    } catch (error) {
      console.log("ERRORR");

      console.error(error);
      throw error;
    }
  };
  // --------------------------------------

  const [trifectaFlows, setTrifectaFlows] = useState(null);
  const [trifectaPlans, setTrifectaPlans] = useState(null);
  const [trifectaConnetions, setTrifectaConnetions] = useState(null);
  const [trifectaDatasets, setTrifectaDatasets] = useState(null);
  const [error, setError] = useState(null);

  // ------------------------------------

  useEffect(() => {
    Promise.all([
      fetchListTrifecta("/trifecta-flows"),
      fetchListTrifecta("/trifecta-plans"),
      fetchListTrifecta("/trifecta-connections"),
      fetchListTrifecta("/trifecta-dataset-library"),
    ])
      .then(
        ([
          trifectaFlowsData,
          trifectaPlansData,
          trifectaConnectionsData,
          trifectaDatasetLibrary,
        ]) => {
          setTrifectaFlows(trifectaFlowsData.data.data);
          setTrifectaPlans(trifectaPlansData.data.data);
          setTrifectaConnetions(trifectaConnectionsData.data.data);
          setTrifectaDatasets(trifectaDatasetLibrary.data.data);
          setLoading(false);
        }
      )
      .catch((error) => {
        console.log("ERRORR");
        setError(error);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return <>error</>;
  }

  return (
    <Box>
      <Box>
        <SidebarContext.Provider>
          <Sidebar />
          <Box
            float="right"
            minHeight="100vh"
            height="100%"
            overflow="auto"
            position="relative"
            maxHeight="100%"
            w={{ base: "100%", xl: "calc( 100% - 290px )" }}
            maxWidth={{ base: "100%", xl: "calc( 100% - 290px )" }}
            transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
            transitionDuration=".2s, .2s, .35s"
            transitionProperty="top, bottom, width"
            transitionTimingFunction="linear, linear, ease"
          >
            <Portal>
              <Box>
                <Navbar
                  onOpen={onOpen}
                  logoText={"Horizon UI Dashboard PRO"}
                  brandText={getActiveRoute(routes)}
                  secondary={getActiveNavbar(routes)}
                  message={getActiveNavbarText(routes)}
                  fixed={false}
                  // handleDownloadFileClick={handleDownloadFileClick}
                  // handleBigQueryClick={handleBigQueryClick}
                  // {...rest}
                />
              </Box>
            </Portal>
            <Box
              mx="auto"
              p={{ base: "20px", md: "30px" }}
              pe="20px"
              minH="100vh"
              pt="50px"
            >
              <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
                <>
                  <SimpleGrid
                    columns={{ base: 1, md: 1, xl: 2 }}
                    gap="20px"
                    mb="20px"
                  >
                    <TableComponent
                      columnsData={[
                        {
                          Header: "NAME",
                          accessor: "name",
                        },
                        {
                          Header: "UPDATED AT",
                          accessor: "updatedAt",
                        },
                        {
                          Header: "CREATED AT",
                          accessor: "createdAt",
                        },
                        // Add more columns as needed
                      ]}
                      tableData={trifectaFlows}
                      tableName="Flows"
                    />
                    <TableComponent
                      columnsData={[
                        {
                          Header: "NAME",
                          accessor: "name",
                        },
                        {
                          Header: "UPDATED AT",
                          accessor: "updatedAt",
                        },
                        {
                          Header: "CREATED AT",
                          accessor: "createdAt",
                        },
                        // Add more columns as needed
                      ]}
                      tableData={trifectaDatasets}
                      tableName="Dataset Libraries"
                    />
                  </SimpleGrid>
                  <SimpleGrid
                    columns={{ base: 1, md: 1, xl: 2 }}
                    gap="20px"
                    mb="20px"
                  >
                    <TableComponent
                      columnsData={[
                        {
                          Header: "NAME",
                          accessor: "name",
                        },
                        {
                          Header: "UPDATED AT",
                          accessor: "updatedAt",
                        },
                        {
                          Header: "CREATED AT",
                          accessor: "createdAt",
                        },
                        // Add more columns as needed
                      ]}
                      tableData={trifectaPlans}
                      tableName="Plans"
                    />
                    <TableComponent
                      columnsData={[
                        {
                          Header: "NAME",
                          accessor: "name",
                        },
                        {
                          Header: "TYPE",
                          accessor: "type",
                        },
                        {
                          Header: "CREATED AT",
                          accessor: "creator.createdAt",
                        },
                        // Add more columns as needed
                      ]}
                      tableData={trifectaConnetions}
                      tableName="Connections"
                    />
                  </SimpleGrid>
                </>
              </Box>
            </Box>
          </Box>
        </SidebarContext.Provider>
      </Box>
    </Box>
  );
}
